import React, { useState } from "react";
import { BsPencil, BsCheck2 } from "react-icons/bs";
import { FiPhone, FiUser, FiMail, FiInfo, FiEye } from "react-icons/fi";
import { TbGenderAndrogyne } from "react-icons/tb";
import profile_Img from "../../../../Assets/Images/user.png";
import { useSelector } from "react-redux";

export default function SettingsView({ setView }) {
  const { userInfo } = useSelector((state) => state.authUser);

  const handleEditClick = () => {
    setView("edit"); // Switch to the settings edit view
  };

  return (
    <section>
      <div className="bg-white border-b pb-0">
        <div className="profile-section p-4 pt-6 rounded-xl max-w-md flex flex-col justify-center items-center gap-4 text-center mx-auto">
          <div className="w-[160px] h-[160px] rounded-full overflow-hidden">
            <img
              src={
                userInfo?.avtarImage ||
                userInfo?.userImage ||
                userInfo?.userMedia ||
                profile_Img
              }
              alt="Group"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="w-full text-center">
            <div className="flex items-center justify-center gap-2 relative z-10">
              <h2 className="text-lg font-semibold text-black pt-1 truncate max-w-xs">
                {userInfo?.name}
              </h2>
            </div>
          </div>
        </div>
      </div>

      {/* Details List */}
      <div className="p-4 space-y-4 max-w-md mx-auto">
        {/* Phone */}
        <div className="flex justify-between items-start">
          <div className="flex items-start gap-3">
            <FiPhone className="mt-[2px] text-black text-md" size={14} />
            <div>
              <div className="flex items-center">
                <span className="font-normal text-sm text-[#7C7C7C] pb-2">
                  Phone Number
                </span>
              </div>
              <span className="text-black text-sm font-semibold">
                (
                {userInfo?.countryCode?.includes("+")
                  ? userInfo?.countryCode
                  : `+${userInfo?.countryCode}`}
                ) {userInfo?.phone}
              </span>
            </div>
          </div>
          <div
            className="mt-1 cursor-pointer text-[var(--primary-color)]"
            onClick={handleEditClick}
          >
            <BsPencil className="text-lg" />
          </div>
        </div>

        {/* Gender */}
        <div className="flex justify-between items-start">
          <div className="flex items-start gap-3">
            <TbGenderAndrogyne className="mt-[2px] text-black text-md"  />
            <div>
              <div className="flex items-center">
                <span className="font-normal text-sm text-[#7C7C7C] pb-2">
                  Gender
                </span>
              </div>
              <span className="text-black text-sm font-semibold">
                {userInfo?.gender}
              </span>
            </div>
          </div>
        </div>

        {/* Mail */}
        <div className="flex justify-between items-start">
          <div className="flex items-start gap-3">
            <FiMail className="mt-[2px] text-black text-md" />
            <div>
              <div className="flex items-center">
                <span className="font-normal text-sm text-[#7C7C7C] pb-2">
                  Mail
                </span>
              </div>
              <span className="text-black text-sm font-semibold">
                {userInfo?.email}
              </span>
            </div>
          </div>
        </div>

        {/* About */}
        <div className="flex justify-between items-start">
          <div className="flex items-start gap-3">
            <FiInfo className="mt-[2px] text-black text-md" size={18} />
            <div>
              <div className="flex items-center">
                <span className="font-normal text-sm text-[#7C7C7C] pb-2">
                  About
                </span>
              </div>
              <span className="text-black text-sm font-semibold">
                {userInfo?.about}
              </span>
            </div>
          </div>
        </div>

        {/* Visibility */}
        <div className="flex justify-between items-start">
          <div className="flex items-start gap-3">
            <FiEye className="mt-[2px] text-black text-md"  />
            <div>
              <div className="flex items-center">
                <span className="font-normal text-sm text-[#7C7C7C] pb-2">
                  Who can see your phone number
                </span>
              </div>
              <span className="text-black text-sm font-semibold">
                {userInfo?.privacy}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
